import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { AncillariesService } from '../../../components/ib-web-ancillaries/ib-web-ancillaries-service';
const controllerInfo = {
    module: 'ib-carbon-footprint',
    inject: ['object', '$uibModalInstance', '$scope', 'CurrencyService', 'localStorageService', 'AncillariesConstants', 'DatalayerUtilsService', 'DatalayerUniqueKeysService', 'CommonsConstants', 'DatalayerConstants', 'AncillariesService', 'CommonsUtilService'],
    required: []
};

export class CarbonFootprintController implements ng.IController {
    public tooltipOpened = false;
    public tooltipComponent = null;
    public model;
    public finalPrice = 0;
    public toggleChecked = false;
    public ancInfo:any = this.localStorageService.get('ancillariesInfo') || {currencies:[{symbol:''}]};
    public stateInitialToggle = false;

    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private $scope: angular.IScope,
        private CurrencyService: CurrencyService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private AncillariesConstants: AncillariesConstant,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerUniqueKeysService: DatalayerUniqueKeysService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private AncillariesService: AncillariesService,
        private CommonsUtilService: CommonsUtilService
    ) {
        this.model = object;
        this.setFinalPrice(0);
        this.toggleChecked = false;
        this.stateInitialToggle = this.model.confirmed;
    }

    $onInit (): void {
        this.$scope.$on('updateToggleCo2Modal', this.updateToggleCo2Modal);
        if (this.model.confirmed) {
            this.setFinalPrice(this.model.price);
            this.toggleChecked = true;
        }
    }
    /**
     * Cancel modal
     * @returns Reject promise
     */
    close = (): void => {
        this.DatalayerUtilsService.updateProcessAndStep([this.AncillariesConstants.APPLICATION_FLOW.BOOKING], [this.CommonsUtilService.getProcess()], [this.DatalayerConstants.DATALAYER_VIEWS.ANCILLARIES], [this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase()]);
        this.$uibModalInstance.dismiss();
    };

    updateToggleCo2Modal = (): void => {
        this.emitToggleAnalytics();

        if (!this.toggleChecked) {
            this.setFinalPrice(0);
        } else {
            this.setFinalPrice(this.model.price);
        }
    };

    emitToggleAnalytics = () => {
        if (this.DatalayerUniqueKeysService.exists(
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODAL_ACTIVE_TOGGLE,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT)
        ) {
            return;
        }

        this.DatalayerUniqueKeysService.setValue(
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODAL_ACTIVE_TOGGLE,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT
        );

        this.DatalayerUtilsService.updateDatalayerEvent(
            '',
            this.DatalayerConstants.DATALAYER_EVENT_TYPES.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.LABEL,
            this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.MODAL_TOGGLE_CLICK
        );
    };

    /**
     * Close modal and apply ancillary if toggle is checked
     * @return Resolve promise
     */
    accept = (): void => {
        this.emitAcceptAnalytics();
        if (this.toggleChecked) {
            if (!this.stateInitialToggle) {
                const kilosCo2Equivalent = this.model.kilosCo2Equivalent;
                const price = this.model.price;
                this.AncillariesService.updateCarbonFootprint(kilosCo2Equivalent, price).then(() => {
                    this.model.confirmed = true;
                    this.AncillariesService.addCarbonFootprintToBasket(this.AncillariesConstants.QUADRIGAM.ANCILLARIES_BKI.toLowerCase(), kilosCo2Equivalent, price);
                }, angular.noop);
            }
        } else {
            if (this.alreadyInBasket()) {
                this.AncillariesService.deleteCarbonFootprint().then(() => {
                    this.model.confirmed = false;
                    this.AncillariesService.deleteCarbonFootprintFromBasket();
                }, angular.noop);
            }
        }
        this.$uibModalInstance.close();
    };

    emitAcceptAnalytics = () => {
        let uniqueKeyValue;
        let eventName;
        if (this.toggleChecked) {
            uniqueKeyValue = this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODAL_ACCEPT_ADD;
            eventName = this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.MODAL_ACCEPT_ADD;
        } else {
            if (!this.model.confirmed) {
                return;
            }
            uniqueKeyValue = this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.VALUES.MODAL_ACCEPT_REMOVE;
            eventName = this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.MODAL_ACCEPT_REMOVE;
        }

        if (this.DatalayerUniqueKeysService.exists(
            uniqueKeyValue,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT)
        ) {
            return;
        }

        this.DatalayerUniqueKeysService.setValue(
            uniqueKeyValue,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.KEYS.ANCILLARIES,
            this.DatalayerConstants.DATALAYER_UNIQUE_CONSTANTS.SUBKEYS.CO2_FOOTPRINT
        );

        this.DatalayerUtilsService.updateDatalayerEvent(
            '',
            this.DatalayerConstants.DATALAYER_EVENT_TYPES.CLICK,
            this.AncillariesConstants.DATALAYER_INFO.ANCILLARIES.CO2_FOOTPRINT.LABEL,
            eventName
        );
    };

    alreadyInBasket = () : boolean => {
        const basket : any = this.localStorageService.get('headerModel');
        return basket?.shoppingBasket?.carbonFootprint?.hasCarbonFootprint;
    };

    setFinalPrice = (price: number) => {
        this.finalPrice = this.CurrencyService.formatPrice(this.CurrencyService.getCurrencyObject(this.ancInfo.currencies[0]), price, true, false, false);
    };

}


try {
    CarbonFootprintController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(CarbonFootprintController.name, CarbonFootprintController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    CarbonFootprintController.$inject = controllerInfo.inject;
    mod.controller(CarbonFootprintController.name, CarbonFootprintController);
}